import { render, staticRenderFns } from "./allComment.vue?vue&type=template&id=5e99c408"
import script from "./allComment.vue?vue&type=script&lang=ts"
export * from "./allComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports